<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0"></h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>

      <!-- Card stats -->
      <div class="stats" v-if="!loading">
        
        <!-- Leads --> 
        <card>
          <h5 class="mb-0">Leads Today</h5>
        </card>

        <div class="row">
          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Created"
              type="gradient-blue"
              :sub-title="leadsCreatedToday"
              icon="ni ni-single-02"
            >
            </stats-card>
          </div>

          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Proposal Sent"
              type="gradient-blue"
              :sub-title="leadsProposalSent"
              icon="ni ni-single-02"
            >
            </stats-card>
          </div>

          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Preapp sent"
              type="gradient-blue"
              :sub-title="leadsAppCreated"
              icon="ni ni-single-02"
            >
            </stats-card>
          </div>


        </div>
        <!-- / Leads --> 

        <!-- Applications --> 
        <card>
          <h5 class="mb-0">Applications Today</h5>
        </card>

        <div class="row">
          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Submitted to Apps Team"
              type="gradient-green"
              :sub-title="appsCreatedToday"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>

          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Forecasted Processing"
              type="gradient-green"
              :sub-title="'£' + appsExpectedSalesToday"

            >
            </stats-card>
          </div>

          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Submitted to Bank"
              type="gradient-green"
              :sub-title="appsSubmittedToBank"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>

        </div>

        <div class="row">

            <div class="col-xl-4 col-md-4">
            <stats-card
              title="Mids Issued"
              type="gradient-green"
              :sub-title="appsMidsIssued"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>

            <div class="col-xl-4 col-md-4">
            <stats-card
              title="Banks U/W WIP"
              type="gradient-green"
              :sub-title="appsWIP"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>

          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Hold Pay"
              type="gradient-green"
              :sub-title="appsHoldPay"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Bank declined"
              type="gradient-green"
              :sub-title="appsBankDeclined"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>

        
            <div class="col-xl-4 col-md-4">
            <stats-card
              title="Bank Cancelled"
              type="gradient-green"
              :sub-title="appsBankCancelled"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>

          <div class="col-xl-4 col-md-4">
            <stats-card
              title="Appication Cancelled"
              type="gradient-green"
              :sub-title="appsApplicationCancelled"
              icon="ni ni-single-copy-04"
            >
            </stats-card>
          </div>
        </div>

        <!-- / Applications --> 
      </div>
      <div v-else>
      <div class="row">
        <div class="col-xl-12">
          <div class="d-flex justify-content-center">
            <i class="fas fa-spinner fa-spin text-white"></i>
          </div>
        </div>
      </div>
      </div>

    </base-header>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";

// Lists
import ActivityFeed from "./ActivityFeed";
import TaskList from "./TaskList";
import UserList from "./UserList";
import ProgressTrackList from "./ProgressTrackList";

// Tables
import LightTable from "./LightTable";
import SocialTrafficTable from "./SocialTrafficTable";
import PageVisitsTable from "./PageVisitsTable";

import { resourceFactory } from "../../resourceFactory";

const dashboardResource = resourceFactory.get("dashboardResource");

export default {
  components: {
    ActivityFeed,
    LineChart,
    BarChart,
    BaseProgress,
    RouteBreadCrumb
  },
  data() {
    return {
      leadsCreatedToday: '0',
      leadsProposalSent: '0',
      leadsAppCreated: '0',
      
      appsCreatedToday: '0',
      appsWIP: '0',
      appsExpectedSalesToday: '0',
      appsMidsIssued: '0',
      appsSubmittedToBank: '0',
      appsHoldPay: '0',
      appsBankDeclined: '0',
      appsBankCancelled: '0',
      appsApplicationCancelled: '0',

      loading: false,
      interval: null,
    };
  },
  created() {
    // Initial
    this.loading = true;
    this.fetch();

    // Set recurring
    this.interval = setInterval(() => this.fetch(), 10000);
  },
  destroyed() {
    console.log('destroyed');
    clearInterval(this.interval);
  },
  methods: {
    fetch() {

      dashboardResource
        .dailyStats()
        .then(response => {
          

          console.log(response);

          // Leads
          this.leadsCreatedToday = response.data.leads.created.toString();          
          this.leadsProposalSent = response.data.leads.proposalSent.toString();
          this.leadsAppCreated = response.data.leads.appCreated.toString();

          // Applications
          this.appsCreatedToday = response.data.applications.created.toString();
          this.appsWIP = response.data.applications.wip.toString();
          this.appsExpectedSalesToday = response.data.applications.expectedSales.toString();
          this.appsMidsIssued = response.data.applications.midsIssued.toString();
          this.appsSubmittedToBank = response.data.applications.submittedToBank.toString();
          this.appsHoldPay = response.data.applications.holdPay.toString();
          this.appsBankDeclined = response.data.applications.bankDeclined.toString();
          this.appsBankCancelled = response.data.applications.bankCancelled.toString();
          this.appsApplicationCancelled = response.data.applications.applicationCancelled.toString();


          this.loading=false;

        })
        .catch(error => {
          console.log(error);
        });
    },
    }
};
</script>
<style scoped>

* >>> .breadcrumb-item {
  font-size:30px;
}

* >>> h5{
  font-size:20px;
}

* >>> .h2{
  font-size:40px;
}

* >>> .card-body{
  padding: 1rem;
}

* >>> .fa-spinner {
  padding:200px;
  font-size:5rem;
}

</style>
